/* src/app/components/feedback-widget/feedback-widget.component.scss */
.feedback-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f59e0b;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 10000;
  transition: all 0.2s ease;
}
.feedback-fab:hover {
  background: #d97706;
  transform: scale(1.05);
}
.feedback-fab.open {
  background: #6b7280;
}
.feedback-panel {
  position: fixed;
  bottom: 92px;
  right: 24px;
  width: 380px;
  max-height: 80vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panel-header {
  padding: 16px 20px;
  background: #f59e0b;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.panel-header .badge {
  background: rgba(255, 255, 255, 0.3);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
}
.panel-body {
  padding: 16px 20px;
  overflow-y: auto;
  max-height: calc(80vh - 60px);
}
.form-group {
  margin-bottom: 12px;
}
.form-group label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}
.form-group .required {
  color: #ef4444;
}
.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #111827;
  background: #f9fafb;
  box-sizing: border-box;
}
.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}
.form-group textarea {
  resize: vertical;
  font-family: inherit;
}
.form-row {
  display: flex;
  gap: 12px;
}
.form-row .half {
  flex: 1;
}
.page-info span {
  font-size: 11px;
  color: #9ca3af;
}
.submit-btn {
  width: 100%;
  padding: 10px;
  background: #f59e0b;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.submit-btn:hover:not(:disabled) {
  background: #d97706;
}
.submit-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}
.success {
  text-align: center;
  padding: 32px 20px;
}
.success .success-icon {
  width: 48px;
  height: 48px;
  background: #10b981;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 12px;
}
.success h4 {
  margin: 0 0 8px;
  color: #111827;
}
.success p {
  margin: 0 0 16px;
  font-size: 13px;
  color: #6b7280;
}
/*# sourceMappingURL=feedback-widget.component.css.map */
